import { cn } from '@/lib/utils'

export type LevelPlayStartHeroVariant = 'journey' | 'quiz'

export interface LevelPlayStartHeroProps {
  variant: LevelPlayStartHeroVariant
  className?: string
}

const HERO_SRC: Record<LevelPlayStartHeroVariant, string> = {
  journey: '/journeys/mascot.png',
  quiz: '/quizzes/mascot.png'
}

/**
 * Ilustração hero da tela inicial do Level Play.
 * Mascot centralizado sobre meia-lua com gradiente lilás (70% da área).
 */
export const LevelPlayStartHero = ({
  variant,
  className
}: LevelPlayStartHeroProps) => (
  <div
    className={cn(
      'relative flex w-full max-w-[320px] min-h-[220px] justify-center items-end',
      className
    )}
  >
    <div
      className="absolute bottom-0 left-1/2 h-[70%] w-full -translate-x-1/2 rounded-t-full bg-gradient-to-t from-transparent to-brand-light"
      aria-hidden
    />
    <img
      src={HERO_SRC[variant]}
      alt=""
      className="relative z-[1] max-h-[200px] w-[min(240px,68vw)] object-contain"
    />
  </div>
)
